export class ProgressTracker {
    private onderleggerId: string;
    private pollInterval: number | null = null;
    private onComplete: ((success: boolean) => void) | null = null;
    
    constructor(onderleggerId: string) {
        this.onderleggerId = onderleggerId;
    }
    
    async start(): Promise<boolean> {
        return new Promise((resolve) => {
            this.onComplete = resolve;
            this.startPolling();
        });
    }
    
    startPolling(): void {
        this.pollInterval = window.setInterval(async () => {
            await this.checkStatus();
        }, 2000); // Poll every 2 seconds
        
        // Initial check
        this.checkStatus();
    }
    
    async checkStatus(): Promise<void> {
        try {
            const response = await fetch(`/api/onderleggers/${this.onderleggerId}`);
            const data = await response.json();
            
            this.updateUI(data);
            
            if (data.status === 'completed') {
                this.stopPolling();
                this.onComplete?.(true);
            } else if (data.status === 'failed') {
                this.stopPolling();
                this.showError(data.error_message);
                this.onComplete?.(false);
            }
            
        } catch (error) {
            console.error('Failed to check status:', error);
        }
    }
    
    updateUI(data: any): void {
        // Update progress bar
        const progressFill = document.getElementById('progress-fill');
        const progressPercentage = document.getElementById('progress-percentage');
        
        if (progressFill) {
            progressFill.style.width = `${data.progress}%`;
        }
        
        if (progressPercentage) {
            progressPercentage.textContent = `${data.progress}%`;
        }
        
        // Update status log
        this.updateStatusLog(data);
    }
    
    updateStatusLog(data: any): void {
        const logList = document.getElementById('progress-log');
        if (!logList) return;
        
        const steps = [
            { threshold: 10, text: '✅ Recipe gegenereerd' },
            { threshold: 20, text: '🔄 PyGISKit gestart...' },
            { threshold: 40, text: '📥 BGT data ophalen...' },
            { threshold: 60, text: '🏘️ BAG3D gebouwen verwerken...' },
            { threshold: 80, text: '🔧 GLB genereren...' },
            { threshold: 95, text: '📦 ZIP archief maken...' },
            { threshold: 100, text: '✅ Klaar!' }
        ];
        
        logList.innerHTML = steps.map(step => {
            const status = data.progress >= step.threshold ? 'complete' :
                          data.progress >= step.threshold - 20 ? 'active' : '';
            return `<li class="${status}">${step.text}</li>`;
        }).join('');
    }
    
    showError(errorMessage: string): void {
        const progressContainer = document.querySelector('.progress-container');
        if (progressContainer) {
            // Build error UI using safe DOM manipulation
            progressContainer.innerHTML = '';
            
            const errorBox = document.createElement('div');
            errorBox.className = 'error-box';
            
            const heading = document.createElement('h2');
            heading.textContent = 'Fout bij genereren';
            
            const message = document.createElement('p');
            message.textContent = errorMessage; // Safe - no XSS
            
            const backBtn = document.createElement('button');
            backBtn.id = 'btn-error-back';
            backBtn.className = 'btn btn-secondary';
            backBtn.style.marginTop = '2rem';
            backBtn.style.width = '100%';
            backBtn.textContent = 'Terug naar start';
            backBtn.addEventListener('click', () => {
                window.location.reload(); // Simple way to reset state
            });
            
            errorBox.appendChild(heading);
            errorBox.appendChild(message);
            errorBox.appendChild(backBtn);
            progressContainer.appendChild(errorBox);
        }
    }
    
    stopPolling(): void {
        if (this.pollInterval) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
    }
}
